import { MainImages } from '@lemon/assets';
import { headers } from '../layout/header/Header';

export const Matching = () => {
    return (
        <div id={headers[4].id} className="w-full h-full flex bg-white items-center justify-center px-4">
            <figure className="max-w-[1200px] mx-auto relative w-full h-full flex flex-col items-center justify-center bg-white text-black pt-[230px]">
                <div className="w-full flex flex-col items-center md:items-start gap-4 md:gap-6">
                    <div className="text-[60px] md:text-[100px] lg:text-[120px] font-bold text-center md:text-left text-balance">
                        {title}
                    </div>

                    <div className="text-[14px] md:text-[18px] lg:text-[20px] text-black/60 text-center md:text-left text-pretty leading-relaxed max-w-[800px]">
                        {description1_1} {description1_2}
                    </div>

                    <div className="text-[14px] md:text-[18px] lg:text-[20px] text-black/60 text-center md:text-left text-pretty leading-relaxed max-w-[900px]">
                        {description2_1} {description2_2}
                    </div>
                </div>

                <div className="flex flex-col md:flex-row items-center justify-center w-full mt-10 md:mt-16 gap-10 pb-20">
                    {/* 왼쪽 이미지 */}
                    <div className="w-full md:w-1/2 flex justify-center">
                        <img
                            src={MainImages.matching}
                            alt="matching_image"
                            className="max-w-full h-auto"
                            onDragStart={e => e.preventDefault()}
                        />
                    </div>

                    {/* 오른쪽 words */}
                    <div className="w-full md:w-1/2 flex flex-wrap gap-[8px] md:gap-[12px] justify-center">
                        {words.map(country => (
                            <div
                                key={country.id}
                                className={`py-2 px-4 text-[14px] md:py-4 md:px-5 md:text-[20px] lg:text-[24px] rounded-full md:rounded-none ${
                                    country.isBold ? 'font-bold bg-primary-black text-white' : 'border border-black/20'
                                }`}
                            >
                                <div>{country.ko}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </figure>
        </div>
    );
};

const title = 'matching';
const description1_1 = '오늘날 콘텐츠 노출은 풍부하지만, 타깃이 아닌';
const description1_2 = '고객에게까지 노출 비중이 높아 전환율 저하가 발생합니다.';

const description2_1 = '이에 EPYT는 사용자의 비주얼 특성이 유사한 집단을 기반으로 예측 가능한';
const description2_2 = '스타일링을 제안하여, 보다 높은 전환율과 만족도를 이끌어냅니다.';

const words = [
    { id: 0, ko: '한국', en: 'Korea', isBold: false },
    { id: 1, ko: '러시아', en: 'Russia', isBold: true },
    { id: 2, ko: '중국', en: 'China', isBold: false },
    { id: 3, ko: '말레이시아', en: 'Malaysia', isBold: false },
    { id: 4, ko: '겨울 브라이트', en: 'Winter Bright', isBold: true },
    { id: 5, ko: '여름 뮤트', en: 'Summer Mute', isBold: false },
    { id: 6, ko: '봄 라이트', en: 'Spring Light', isBold: false },
    { id: 7, ko: '21호', en: 'Midi-Light', isBold: false },
    { id: 8, ko: '23호', en: 'Tan', isBold: false },
    { id: 9, ko: '25호', en: 'Midi-Deep', isBold: true },
    { id: 10, ko: '핑크 베이스', en: 'Pink Base', isBold: false },
    { id: 11, ko: '올리브 베이스', en: 'Olive Base', isBold: true },
    { id: 12, ko: '옐로우 베이스', en: 'Yellow Base', isBold: false },
];
